"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BehaviourAdapter {
    constructor(api, dateTimeProvider, dateTimeBridge) {
        this.getDateRange = async (userId, dateRange) => {
            const days = await this.api.getDateRange(userId, dateRange);
            return {
                days: days.days.map((day) => {
                    const userDate = this.dateTimeBridge.userDate(day.date);
                    return {
                        day: this.dateTimeProvider.dayOfWeek(userDate),
                        date: this.dateTimeProvider.fromDateTimeToDate(userDate),
                        isDone: day.isDone,
                        lessonOrdinalNumber: day.lessonOrdinalNumber,
                        lessonTitle: day.lessonTitle,
                    };
                }),
            };
        };
        this.getDate = async (userId, date) => {
            const day = await this.api.getDate(userId, date);
            const userDate = this.dateTimeBridge.userDate(day.date);
            return {
                ...day,
                date: userDate,
                memberAnswer: day.memberAnswer,
            };
        };
        this.api = api;
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeBridge = dateTimeBridge;
    }
}
exports.default = BehaviourAdapter;
//# sourceMappingURL=BehaviourAdapter.js.map